interface Headers {
  [index: string]: string;
}

const headers: Headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

const postFileHeaders: Headers = {
  'Content-Type': 'multipart/form-data'
};

export {
  headers,
  postFileHeaders
}